import store from "../store/store";
import Liveness2D from "./liveness/Liveness2D";
import LivenessFacetec from "./liveness/LivenessFacetec";
import LivenessSerasa from "./liveness/LivenessSerasa";

export default class LivenessService{

    constructor() {
        this.$store = store;
        this.liveness = this.loadLiveness();
    }

    carregar(reload= false){
        let id = this.liveness.gerarID();
        if(document.getElementById(id)){
            return new Promise(resolve => resolve());
        }
        return this.liveness.carregarArquivos(id)
            .then(() => this.preLoad(reload));
    }

    preLoad(reload = false){
        let componente_nao_carregado = (typeof window.selfie  !== 'object' || !(window.selfie instanceof window.BrScanSDKSelfie.Selfie));
        if(componente_nao_carregado || reload){
            this.liveness.preLoad();
            this.$store.dispatch('definirComponenteSelfieCarregado',true);
        }
    }

    loadLiveness(){
        switch (this.$store.state.liveness){
            case 1:
                return new Liveness2D();
            case 2:
                return new LivenessFacetec();
            case 3:
                return new LivenessSerasa();
        }
    }

    getRouteName(){
        return this.liveness.getRouteName();
    }


}



// WEBPACK FOOTER //
// ./src/services/LivenessService.js